/**
 * Query keys for DoseSpot Clinician-related data.
 */
export const dosespotClinicianKeys = {
  all: ['dosespot-clinician'] as const,

  // Admin lists
  usersWithRecords: () => [...dosespotClinicianKeys.all, 'users-with-records'] as const,
  usersWithoutRecords: () => [...dosespotClinicianKeys.all, 'users-without-records'] as const,

  // My clinician info
  myInfo: () => [...dosespotClinicianKeys.all, 'my-info'] as const,
  myRegistrationStatus: () => [...dosespotClinicianKeys.all, 'my-registration-status'] as const,
};
